import type { DirectiveBinding } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  _clickOutside?: (event: MouseEvent) => void;
}

interface ClickOutsideBinding extends DirectiveBinding {
  value: () => void;
  modifiers: {
    exclude?: boolean;
  };
}

export const vClickOutside = {
  mounted(el: ClickOutsideElement, binding: ClickOutsideBinding) {
    el._clickOutside = (event: MouseEvent) => {
      // Get all elements with exclude modifier
      const excludeElements = document.querySelectorAll(
        '[data-click-outside-exclude]'
      );

      // Check if click is on excluded element
      const isExcluded = Array.from(excludeElements).some((excludeEl) =>
        excludeEl.contains(event.target as Node)
      );

      // If click is outside and not on excluded element, call the handler
      if (!el.contains(event.target as Node) && !isExcluded) {
        binding.value();
      }
    };

    document.addEventListener('click', el._clickOutside);
  },

  unmounted(el: ClickOutsideElement) {
    if (el._clickOutside) {
      document.removeEventListener('click', el._clickOutside);
      delete el._clickOutside;
    }
  }
};
